import { monotonicNow, visible } from './websocketLifecycle.js'
import { parseContract } from '../contracts/generated/contracts.js'

export class WebSocketHeartbeat {
    constructor(service) {
        this.service = service
        this.timer = null
        this.sequence = 0
        this.reset()
    }
    reset() {
        this.pending = null
        this.negotiated = false
        this.failures = 0
        this.lastIncoming = monotonicNow()
        this.lastAck = null
        this.lastSent = null
        this.rtt = null
    }
    start() {
        this.stop()
        this.lastTick = monotonicNow()
        this.lastWall = Date.now()
        this.timer = setInterval(() => this.tick(), 1000)
    }
    stop() { clearInterval(this.timer); this.timer = null; this.pending = null }
    probe() {
        if (!this.service.isConnected()) return
        const now = monotonicNow()
        this.pending = { sequence: ++this.sequence, sent: now }
        this.lastSent = now
        this.service.send({ type: 'client_heartbeat', protocol_version: 2,
            sequence: this.sequence, connection_id: this.service.connectionId })
    }
    receive(data) {
        if (!data || typeof data !== 'object' || typeof data.type !== 'string') return false
        const now = monotonicNow()
        if (data.type === 'heartbeat_ack') {
            try { parseContract('websocket_heartbeat_ack', data) } catch { return true }
            if (data.protocol_version !== 2 || data.connection_id !== this.service.connectionId ||
                !this.pending || data.sequence !== this.pending.sequence ||
                typeof data.server_connection_id !== 'string') return true
            this.negotiated = true
            this.rtt = Math.max(0, now - this.pending.sent)
            this.lastAck = now
            this.pending = null
            this.failures = 0
            this.service.serverIdentity = {
                server_connection_id: data.server_connection_id,
                server_instance_id: data.server_instance_id, server_release: data.server_release,
            }
            this.service.confirmReady()
        } else if (!this.negotiated) {
            this.failures = 0
            this.service.confirmReady()
        }
        this.lastIncoming = now
        if (data.type === 'ping') this.service.send({ type: 'pong', ts: Date.now() })
        return ['ping', 'heartbeat_ack'].includes(data.type)
    }
    tick() {
        const now = monotonicNow()
        const wall = Date.now()
        const elapsed = now - this.lastTick
        const drift = Math.abs((wall - this.lastWall) - elapsed)
        this.lastTick = now
        this.lastWall = wall
        this.service.timerLagMs = Math.max(0, elapsed - 1000, drift)
        if (!visible()) {
            if (this.lastSent === null || now - this.lastSent >= 22000) this.probe()
            return
        }
        if (elapsed > 11000 || drift > 10000) { this.service.resume('timer_gap'); return }
        if (this.service.isConnecting) {
            if (now - this.service.connectStarted >= 15000) this.service.retire('connect_timeout')
            return
        }
        if (!this.service.isConnected()) return
        if (this.negotiated && this.pending && now - this.pending.sent >= 15000) {
            if (++this.failures >= 2) { this.service.retire('active_probe_timeout'); return }
            this.probe()
        } else if (!this.negotiated && now - this.lastIncoming >= 70000) {
            this.service.retire('legacy_receive_timeout')
        } else if (!this.pending && (this.lastSent === null || now - this.lastSent >= 22000)) {
            this.probe()
        } else if (!this.negotiated && now - this.lastSent >= 22000) this.probe()
    }
    resume() {
        this.pending = null
        this.failures = 0
        this.lastIncoming = monotonicNow()
        this.probe()
    }
}
